
import React from "react";
import { useIntl } from "react-intl";

import { useSelector } from "@tdp/core";
import {
  EntityType,
  Period,
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  ChartAreaLine,
  IPeriodWiseSingleLineDateUsageDataPoints,
  MultiWidgetContainer,
  EmptyState
} from '@tdp/modules/apps';

export const AreaLineWidget: React.FC<{
  status: AnalyticsV2WidgetLoadingState
  size: AnalyticsV2WidgetSize
  data?: IPeriodWiseSingleLineDateUsageDataPoints
  header: string
}> = React.memo(({ header, size, data, status }) => {

  const intl = useIntl();
  const filter = useSelector((state) => state.analyticsFilter.filters);

  const chartLegend = filter.entityType === EntityType.User ?
    intl.formatMessage({ defaultMessage: "Active users", description: "Short name for the metric analyticsMetricNameMau30. For metric explanation see analyticsMetricTooltipTextMau30" }) :
    intl.formatMessage({ defaultMessage: "Active tenants", description: "Short name for the metric analyticsMetricNameMat30. For metric explanation see analyticsMetricTooltipTextMat30" })


  const daily = data?.[Period.Daily]
    ? <ChartAreaLine data={data[Period.Daily]} legend={chartLegend} period={Period.Daily} />
    : <EmptyState />;

  const weekly = data?.[Period.Weekly]
    ? <ChartAreaLine data={data[Period.Weekly]} legend={chartLegend} period={Period.Weekly} />
    : <EmptyState />;

  const monthly = data?.[Period.Monthly]
    ? <ChartAreaLine data={data[Period.Monthly]} legend={chartLegend} period={Period.Monthly} />
    : <EmptyState />;

  return <MultiWidgetContainer
    size={size}
    header={header}
    loadingState={status}
    daily={daily}
    weekly={weekly}
    monthly={monthly}
  />
});